import PropTypes from "prop-types";
import {Link} from "react-router-dom";
import Check from "components/helpers/check";
import {displayDateTime} from "lib/ext/string";
import {useDelete} from "lib/hooks/use-pagination";

function Row({record}) {
  const onDelete = useDelete({check: "Are you sure you want to delete this page?", record});

  return (
    <tr>
      <td><Check checked={record.active} /></td>
      <td>{record.rank}</td>
      <td>{record.template}</td>
      <td>{record.name}</td>
      <td>{record.path}</td>
      <td>{displayDateTime(record.created_at)}</td>
      <td>
        <div className="btn-group" role="group" aria-label="Actions">
          <a className="btn btn-sm btn-green" href={`/${record.path}`} rel="noreferrer" target="_blank">View</a>
          <Link className="btn btn-sm btn-blue" to={`/admin/pages/${record.id}`}>Edit</Link>
          <button type="button" className="btn btn-sm btn-red" onClick={onDelete}>Destroy</button>
        </div>
      </td>
    </tr>
  );
}

Row.propTypes = {
  record: PropTypes.shape({
    active: PropTypes.bool.isRequired,
    created_at: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    rank: PropTypes.number.isRequired,
    template: PropTypes.string.isRequired
  }).isRequired
};

export default Row;
